import { createGlobalStyle } from "styled-components";
import { colors } from "../constants/colors";
import { sizes, font } from "../constants/fonts";

const GlobalStyle = createGlobalStyle`
  body {
    color: ${colors.black};
    overflow-x: hidden;
    height: 100dvh;
    /* font-family: 'ALSHauss-Black', sans-serif; */
  }

  #root {
    height: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    main {
      flex: 1
    }
  }

  section {
    /* margin: 50px 0 !important; */
    padding: 50px 0; 
  }

  .title {
    position: relative;
    font-size: ${sizes.title};
    text-transform: uppercase;
     font-family: ${font.semibold};
    margin-bottom: 50px;
    padding-bottom: 10px;

    &::after {
      content: '';
      position: absolute;
      height: 2px;
      width: 200px;
      bottom: 0;
      left: 0;
      background-color: ${colors.primary};
    }
  }

  .desc {
    font-size: ${sizes.desc};
     font-family: ${font.regular};
  }

  .justify {
    text-align: justify;
  }

  .lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 25px;
  height: 25px;
}
.lds-spinner div {
  transform-origin: 15px 15px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 15px;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #fff;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

`;

export default GlobalStyle;
